import { useSelector } from "react-redux"

const useSystem = () => {
  return {
    apiLoading: useSelector(state => state.system.apiLoading),
  }
}

export default useSystem
